export const BLOGCAROUSEL_LIST_ATTEMPT = "BLOGCAROUSEL_LIST_ATTEMPT";
export const BLOGCAROUSEL_LIST_FAILED = "BLOGCAROUSEL_LIST_FAILED";
export const BLOGCAROUSEL_LIST_SUCCESS = "BLOGCAROUSEL_LIST_SUCCESS";

export const LOGOUT = "LOGOUT";